(() => {
  const initialise = root => {
    if (root.dataset.purchaseReady === 'true') return;
    root.dataset.purchaseReady = 'true';
    const form = root.querySelector('form');
    const options = [...root.querySelectorAll('[data-celluma-variant]')];
    const submit = root.querySelector('[data-purchase-submit]');
    const selection = root.querySelector('[data-purchase-selection]');
    const dailyCost = root.querySelector('[data-daily-cost]');
    const dailyAmount = root.querySelector('[data-daily-cost-amount]');
    const whatsapp = root.querySelector('[data-purchase-whatsapp]');
    const message = root.querySelector('[data-purchase-wechat-message]');
    const copy = root.querySelector('[data-purchase-copy]');
    const copyStatus = root.querySelector('[data-purchase-copy-status]');

    const update = (updateUrl = false) => {
      const selected = options.find(input => input.checked);
      if (!selected) return;
      const available = selected.dataset.variantAvailable === 'true' && Number(selected.dataset.variantPrice) > 0;
      if (submit) {
        submit.disabled = !available;
        submit.textContent = available ? root.dataset.addLabel : root.dataset.unavailableLabel;
      }
      if (selection) {
        selection.textContent = available ? selected.dataset.variantPriceText : root.dataset.unavailableLabel;
        selection.hidden = false;
      }
      if (dailyCost && dailyAmount) {
        dailyCost.hidden = Number(selected.dataset.variantPrice) <= 0;
        dailyAmount.textContent = selected.dataset.variantDailyPrice || '';
      }
      const enquiry = selected.dataset.variantEnquiry;
      if (whatsapp && enquiry) whatsapp.href = 'https://wa.me/6594468877?text=' + encodeURIComponent(enquiry);
      if (message && enquiry) message.value = enquiry;
      if (copyStatus) copyStatus.textContent = '';
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selected.value);
        window.history.replaceState(window.history.state, '', url);
      }
      root.dispatchEvent(new CustomEvent('celluma:variant-change', {
        bubbles: true,
        detail: { id: selected.value, title: selected.dataset.variantTitle, available }
      }));
    };

    options.forEach(input => input.addEventListener('change', () => update(true)));
    if (form) {
      form.addEventListener('submit', event => {
        const selected = options.find(input => input.checked);
        if (!selected || selected.disabled || Number(selected.dataset.variantPrice) <= 0) {
          event.preventDefault();
          options.find(input => !input.disabled)?.focus();
        }
      });
    }
    if (copy && message && copyStatus) {
      copy.hidden = false;
      copy.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(message.value);
          copyStatus.textContent = copyStatus.dataset.success;
        } catch {
          message.focus();
          message.select();
          copyStatus.textContent = copyStatus.dataset.failure;
        }
      });
    }
    update();
  };
  document.querySelectorAll('[data-celluma-purchase]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-celluma-purchase]').forEach(initialise);
  });
})();
